// https://reactjs.org/docs/javascript-environment-requirements.html
import 'core-js/es/map';
import 'core-js/es/set';
// import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import GlobalStyle from './assets/style/GlobalStyle';
import Routes from './routes';
import store from './stores/store';
// utils
import { getRelativePath } from './util/paths/relative';

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle />
    <BrowserRouter basename={getRelativePath()}>
      <Routes />
    </BrowserRouter>
    <ToastContainer
      className="toast"
      position="top-right"
      pauseOnHover
      closeOnClick
      newestOnTop
      autoClose={3000}
    />
  </Provider>,
  document.getElementById('root'),
);
